import React from "react";
import { useDispatch, useSelector } from "react-redux";
import SingleSelect from "../../../components/commonComponents/Selectors/SingleSelect";
import { updateStateData } from "../../../Store/actions";

const MarketingFilters = ({ redux_param_name, reduxKeywordToSaveValue }) => {
  const userStateData = useSelector((state) => state.userSelections);
  const dispatchAction = useDispatch();
  const [activitySelection, setActivitySelection] = React.useState({});
  const [dataLoaded, setDataLoaded] = React.useState(false);
  const activityOptions =
    typeof userStateData.activityOptions !== "undefined" && userStateData.activityOptions.length !== 0
      ? userStateData.activityOptions.sort()
      : [];

  React.useEffect(() => {
    if (activityOptions.length !== 0) {
      setActivitySelection({ value: activityOptions[0], label: activityOptions[0] });
      dispatchAction(
        updateStateData({
          [reduxKeywordToSaveValue]: {
            ...userStateData[reduxKeywordToSaveValue],
            [redux_param_name]: activityOptions[0],
          },
        })
      );
    }
    setTimeout(() => {
      setDataLoaded(true);
    }, 1000);
    
  }, []);

  return (
    <>
      {/* ------------ activity type --------------- */}
      {dataLoaded === true && (
        <SingleSelect
          enableFullWidth={true}
          label={"Activity Type"}
          selectionCheck={(option, value) => option.label === value.label}
          options={activityOptions.map((activityName) => {
            return { value: activityName, label: activityName };
          })}
          defaultVal={activitySelection}
          onChangeCall={(selectedOption) => {
            let userChoices = selectedOption.value;
            setActivitySelection(selectedOption);
            dispatchAction(
              updateStateData({
                [reduxKeywordToSaveValue]: {
                  ...userStateData[reduxKeywordToSaveValue],
                  [redux_param_name]: userChoices,
                },
              })
            );
          }}
        />
      )}
    </>
  );
};

export default MarketingFilters;
